import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
    return (
        <header className="site-header">
            <div className="header-background">
                <div className="header-content">
                    <div className="logo-section">
                        <Link to="/" className="logo-link">
                            <picture>
                                <source
                                    media="(max-width: 480px)"
                                    srcSet="/NYX_NoCode-300.webp"
                                    type="image/webp"
                                />
                                <source
                                    media="(max-width: 480px)"
                                    srcSet="/NYX_NoCode-1200.png"
                                />
                                <source
                                    media="(max-width: 768px)"
                                    srcSet="/NYX_NoCode-600.webp"
                                    type="image/webp"
                                />
                                <source
                                    media="(max-width: 768px)"
                                    srcSet="/NYX_NoCode-1200.png"
                                />
                                <source
                                    srcSet="/NYX_NoCode-1200.webp"
                                    type="image/webp"
                                />
                                <img
                                    src="/NYX_NoCode-1200.png"
                                    alt="NYX NoCode AI Transforms Classrooms into Creative Studios"
                                    className="header-logo"
                                    fetchpriority="high"
                                />
                            </picture>
                        </Link>
                        <div className="tagline">
                            <span className="tagline-main">NYX NoCode AI Transforms Classrooms into Creative Studios</span>
                            <span className="tagline-sub">Doodle-to-Prompt AI Platform - No Coding Required - Free for Verified Educators</span>
                        </div>
                    </div>
                    
                    <div className="header-mountains"></div>
                </div>
                
                <div className="header-gradient-overlay"></div>
            </div>
        </header>
    );
};

export default Header;